<template lang="html">
  <v-container class='fluid'>
    <v-layout align-center justify-center>
      <v-flex xs10>
        <v-card class="text-xs-center">
          <basic-toolbar :title="'Trocar coordenador da ação'"></basic-toolbar>
          <v-card-text>
            <v-form v-model="formularioValido" ref="form">
            <v-container>

              <v-layout row wrap justify-space-between>
                <v-flex xs12>
                  <v-text-field
                    label='Coordenador atual'
                    v-model="integrante.nome"
                    readonly
                    max-height="400">
                  </v-text-field>
                </v-flex>
              </v-layout>

              <p class="mt-1"></p>

              <v-layout row wrap justify-space-between>
                <v-flex xs12>
                  <v-select
                    label='Novo coordenador'
                    :items="listaIntegrantes"
                    eager
                    v-model="novoCoordenador"
                    item-text="nome"
                    item-value="idParticipante"
                    prepend-icon="dashboard"
                    max-height="400"
                    return-object
                    required
                    autocomplete
                    :rules="regrasBasicas" >
                  </v-select>
                </v-flex>
              </v-layout>

            </v-container>
            </v-form>
            <v-divider></v-divider>
            <v-card-actions>
              <v-btn color="primary" text @click="$router.go(-1)">Cancelar</v-btn>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="trocarCoordenador" :disabled="!formularioValido">Trocar coordenador</v-btn>
            </v-card-actions>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import BasicToolbar from '@/components/toolbars/basic-toolbar'
  import ToolTip from '@/components/app-layouts/app-tooltip/tooltip'
  import DataMenu from '@/components/c-date-menu'
  import projetos from '@/utils/projetos'
  import { mapActions } from 'vuex'

  export default {
    props: ['idProjeto', 'idParticipante'],
    data: () => ({
      formularioValido: false,
      listaIntegrantes: [],
      novoCoordenador: {},
      integrante: {
        nome: '',
        dataInicial: '',
        dataFinal: '',
        funcao: {},
        titulacao: {},
        ativo: true,
        cargaHoraria: 0,
        obsParticipante: ''
      },
      regrasBasicas: [
        (input) => !!input || 'Este campo é obrigatório'
      ]
    }),
    methods: {
      ...mapActions('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']),
      trocarCoordenador: function () {
        this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Trocando coordenador.' })
        projetos.putCoordenador(this.idProjeto, this.novoCoordenador.idParticipante)
        .then(response => {
          this.SHOW_SNACKBAR({snackbarType: 'success', snackbarText: response.body.mensagem})
          this.$router.push({name: 'IntegrantesProjeto', params: {idProjeto: this.idProjeto}})
        })
        .catch(error => {
          this.SHOW_SNACKBAR({snackbarType: 'error', snackbarText: error.body.mensagem})
        })
        .finally(() => {
          this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Trocando coordenador.' })
        })
      },
      carregaListaIntegrantes: function (idProjeto) {
        this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando integrantes.' })
        projetos.getIntegrantesDoProjeto(idProjeto)
        .then(response => {
          var listaIntegrantesAux = []
          listaIntegrantesAux = response.data.slice()
          listaIntegrantesAux = listaIntegrantesAux.filter(
            function (el) {
              return el != null && el.situacao === 'A' && el.idParticipante !== this.idParticipante
            }, this
          )
          this.listaIntegrantes = listaIntegrantesAux.slice()
        })
        .catch(error => {
          console.log('Erro ao mandar o request' + error)
        })
        .finally(() => {
          this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando integrantes.' })
        })
      },
      carregaIntegrante: function (idProjeto, idIntegrante) {
        this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando integrante.' })
        projetos.getIntegrante(idProjeto, idIntegrante)
        .then(response => {
          this.integrante = response.data
        })
        .catch(error => {
          console.log('Erro ao mandar o request' + error)
        })
        .finally(() => {
          this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando integrante.' })
        })
      }
    },
    mounted () {
      this.carregaListaIntegrantes(this.idProjeto)
      this.carregaIntegrante(this.idProjeto, this.idParticipante)
    },
    components: {
      'basic-toolbar': BasicToolbar,
      'tooltip': ToolTip,
      'c-date-menu': DataMenu
    }
  }
</script>



// WEBPACK FOOTER //
// trocar-coordenador.vue?770c1f25